import { useState } from 'react';
import { toast } from 'react-toastify';

import { useAiAssistantStatusQuery, useCreateNewAiAssistantDialogMutation } from '@query';

import { useRelatedEntity } from '@shared/common/components/AiAgent/lib/aiAgent';
import { useNavLayout } from '@shared/common/components/NavLayout';
import { MoleculorSocketEndpointKey, useMoleculorSocket } from '@shared/common/providers/socket';

import { WelcomeBlock } from './WelcomeBlock/WelcomeBlock';

type NewChatProps = {
  backToChat: () => void;
};

export const NewChatScreen = ({ backToChat }: NewChatProps) => {
  const { socket } = useMoleculorSocket();
  const { user } = useNavLayout();

  const { isPending, isLoading } = useAiAssistantStatusQuery({ enabled: !!user });
  const [isSocketLoading, setIsSocketLoading] = useState(false);

  const { mutateAsync: createDialog, isPending: isCreateDialogPending } =
    useCreateNewAiAssistantDialogMutation();

  const { relatedEntity } = useRelatedEntity();

  const clickButton = async (message: string) => {
    const response = await createDialog();
    const newChatId = response.info.id;

    if (newChatId) {
      localStorage.setItem('currentSessionChatId', newChatId);

      try {
        setIsSocketLoading(true);
        await socket?.emitWithAck(MoleculorSocketEndpointKey.ASSISTANT, {
          message: { content: message },
          context: {
            ...(!!relatedEntity && { relatedEntity }),
          },
        });
        setIsSocketLoading(false);
        backToChat();
      } catch (e) {
        toast.error('Failed to send message. Try again later.');
      }
    }
  };

  if (isPending || isLoading || isCreateDialogPending || isSocketLoading) {
    return (
      <div className="flex justify-center items-center h-full">
        <h2 className="text-h2-a">Loading...</h2>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col justify-between h-full relative">
      <div className="flex flex-col gap-2 justify-end items-center w-full h-full overflow-hidden">
        <div className="overflow-y-auto h-full px-4 max-md-msq:px-3">
          <WelcomeBlock onCardClick={(message) => clickButton(message)} />
        </div>
      </div>
    </div>
  );
};
